import type { SalesContextCode } from '@apparatix/stores/usePricingStore';

/**
 * Shared across ManagePricing/PricingBulkEditModal/InventoryPricingTab/PreviewPricing so the
 * underlying Intl formatting stays in one place. `fallback` is a per-caller display choice, not a
 * formatting difference — e.g. PricingBulkEditModal shows "—" for a never-priced field instead of
 * the grid's "$0.00" default, since a bulk-edit preview treats "no value yet" as "nothing to show"
 * rather than an implied zero rate.
 */
export const formatCurrency = (
  value: string | number | null | undefined,
  fallback: string = '$0.00',
): string => (value === null || value === undefined
  ? fallback
  : Number(value).toLocaleString(undefined, { style: 'currency', currency: 'USD' }));

export const toDateString = (date: Date | null): string | undefined => {
  if (date === null) {
    return undefined;
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const parseDate = (date: string): Date => new Date(`${date}T00:00:00`);

export const CONTEXT_STYLES: Record<SalesContextCode, { label: string; banner: string }> = {
  local: { label: 'AE Sales', banner: 'border-blue-400 bg-blue-50 text-blue-900' },
  national: { label: 'Automated Sales', banner: 'border-purple-400 bg-purple-50 text-purple-900' },
};

export const CONTEXT_OPTIONS: { code: SalesContextCode; name: string }[] = [
  { code: 'local', name: CONTEXT_STYLES.local.label },
  { code: 'national', name: CONTEXT_STYLES.national.label },
];
